"use client";

import { ToastContainer } from "react-toastify";
import dynamic from "next/dynamic";

const LayoutProvider = dynamic(() => import("@/context/useLayoutContext").then((mod) => mod.LayoutProvider), {
	ssr: false,
});
const AppProvidersWrapper = ({ children }) => {

	return (
	
			<LayoutProvider>
		
					{/* <TitleProvider> */}
					{/* <NotificationProvider> */}
					{children}
					<ToastContainer theme='colored' />
					{/* </NotificationProvider> */}
					{/* </TitleProvider> */}
			
			</LayoutProvider>

	);
};
export default AppProvidersWrapper;
